
$(function () {
  //ハンバーガーメニュー
  $('.menu-trigger').on('click', function () {
    $(this).toggleClass('active');
    return false;
  });
  // ヘッダークラス付与
  $('.menu-trigger').click(function () {
    $('header').toggleClass('openNav');
  });


  //ページトップに戻る
  var topBtn = $('#pageTop');
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 1000) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });



  // 蛍光ペン
  $(window).scroll(function () {
    $(".marker").each(function () {
      var position = $(this).offset().top; //ページの一番上から要素までの距離を取得
      var scroll = $(window).scrollTop(); //スクロールの位置を取得
      var windowHeight = $(window).height(); //ウインドウの高さを取得
      if (scroll > position - windowHeight) { //スクロール位置が要素の位置を過ぎたとき
        $(this).addClass('active'); //クラス「active」を与える
      }
    });
  });

  // aboutモーダル画像
  $('.grid-container .grid-item').click(function () {
    var imgSrc = $(this).children('img').attr('src');
    var title = $(this).data('title');
    var description = $(this).data('description');
    var link = $(this).data('link');
    $('.bigimg .img img').attr('src', imgSrc);
    $('.flame h3').text(title);
    $('.flame .txt').text(description); // '.txt' クラスに対してテキストを設定
    $('.flame .connectionlink').attr('href', link).text(link); // 'link' をそのままテキストとして表示
    $('.modal').fadeIn();
    $('body,html').css('overflow-y', 'hidden');
    return false;
  });
  $('.gallry .close-btn').click(function () {
    $('.modal').fadeOut();
    $('body,html').css('overflow-y', 'visible');
    return false
  });
});
// ----------------------
// Swiper 初期化（要素が存在する場合のみ）
const mySwiper = new Swiper('.card .swiper', {
  slidesPerView: 3, // ←枚数
  centeredSlides: true, // 中央寄せが不要ならfalse、必要ならtrue
  spaceBetween: 24,
  grabCursor: true,
  speed: 1000,
  loop: true,
  loopAdditionalSlides: 2,
  watchSlidesProgress: true,
  initialSlide: 1,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.card .swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.card .swiper-button-next',
    prevEl: '.card .swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 2, // 幅0〜767px → 1枚表示
    },
    768: {
      slidesPerView: 3, // 幅768px以上 → 4枚表示
    },
  },
});

